
<template>
  <div class="fenye">
    <div class="fybtn" @click="gotoShouye">首页</div>
    <div class="fybtn" @click="gotoShangyiye">上一页</div>
    <div class="fybtn" @click="gotoXiayiye">下一页</div>
    <div class="fybtn" @click="gotoWeiye">尾页</div>
  </div>
</template>
<script>
export default {
  name: 'Fenye',
  props:{
    parentPageNo: Number,
    pages: Number,
    total:Number,
  },
  data:{

  },
  methods:{
    gotoShouye(){
      this.parentPageNo = 0;
      this.$emit("parentToRefresh",this.parentPageNo);
    },
    gotoShangyiye(){
      if(this.parentPageNo != 0){
        this.parentPageNo = this.parentPageNo-1;
      }
      this.$emit("parentToRefresh",this.parentPageNo);
    },
    gotoXiayiye(){
      if(this.parentPageNo < this.pages){
        this.parentPageNo = this.parentPageNo+1;
      }
      this.$emit("parentToRefresh",this.parentPageNo);
    },
    gotoWeiye(){
      this.parentPageNo = this.pages;
      this.$emit("parentToRefresh",this.parentPageNo);
    }
  }
}
</script>
